var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-white p-3"},[_c('policies')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }